import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Message } from 'src/app/models/message';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnChanges {

  @Input() message: string;
  @Input() status: string;

  msg: Message = { message: null, status: null };
  hiddenMsg: boolean = true;

  constructor() { }

  ngOnChanges() {
    this.timingMsg(this.message, this.status);
  }

  timingMsg(msg: string, status: string) {
    console.log("Status timingMsg: ",msg," ", status);
    this.setMessage(msg);
    this.setStatus(status);
    this.hiddenMsg = false;
    setTimeout(() => {
      this.setMessage(null);
      this.setStatus(null);
      this.hiddenMsg = true;
    }, 3000);
  }

  setMessage(msg: string) {
    this.message = msg;
  }

  setStatus(status: string) {
    this.status = status;
  }

}
